import { render } from "./TvmBbTradeValue.vue?vue&type=template&id=a1c0eb02&scoped=true"
import script from "./TvmBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmBbTradeValue.vue?vue&type=style&index=0&id=a1c0eb02&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c0eb02"]])

export default __exports__